import { EDocumentType } from '../enums/documents.enum';

export const DOCUMENT_TYPES: string[] = [
    EDocumentType.BOOK,
    EDocumentType.REPORT,
    EDocumentType.TREND,
];
